// @flow


import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { openDialog } from '../../../base/dialog';
import { IconVoiceCommand } from '../../../base/icons';
import { CircularLabel } from '../../../base/label';
import { isLocalParticipantModerator } from '../../../base/participants';
import { Tooltip } from '../../../base/tooltip';

import { VoiceCommandDialog } from './VoiceCommandDialog';

declare var interfaceConfig: ?Object;

/**
 * Voice Command Label for Abstract labels.
 *
 * @returns {JSX}
 */
export default function VoiceCommandLabel() {
    const buttons = [ ...new Set(interfaceConfig.TOOLBAR_BUTTONS) ];
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isModerator = useSelector(state => isLocalParticipantModerator(state));


    if (!buttons.includes('voicecommand') || !isModerator) {
        return null;
    }

    /**
     * On CLick for label.
     *
     * @returns {void}
     */
    function onClickedLabel() {
        dispatch(openDialog(VoiceCommandDialog));
    }

    return (
        <div>
            <Tooltip
                content = { t('voicecommand.vcLabel') }
                position = { 'left' }>
                <CircularLabel
                    className = 'vc'
                    icon = { IconVoiceCommand }
                    onClick = { onClickedLabel } />
            </Tooltip>
        </div>
    );
}

